import {DEPARTMENT_NAME_REGEX} from '../constants/constants';
import {ValidationText} from '../types/client-management/departmentTypes';
import {t} from 'i18next';

export const isValidDepartmentName = (name: string): boolean => {
  return DEPARTMENT_NAME_REGEX.test(name);
};

export const nameValidationText: ValidationText = {
  required: t('validation.required'),
  specialChar: t('validation.nameSpecialChar'),
  maxLength: t('validation.maxLength', {length: 50}),
};
export const descriptionValidationText: ValidationText = {
  maxLength: t('validation.maxLength', {length: 500}),
};
export const branchValidationText: ValidationText = {
  required: t('validation.required'),
};
